import { useEffect, useState } from "react";
import { ArrowUpCircle } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function ScrollToTop() {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > window.innerHeight * 1.5);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <button
      onClick={scrollToTop}
      aria-label={t("hero.scrollTopAria")}
      className={`hidden md:block fixed md:bottom-20 md:right-8 z-50 transition-opacity duration-300 cursor-pointer
      ${visible ? "opacity-100" : "opacity-0 pointer-events-none"}`}
    >
      <ArrowUpCircle className="text-brand dark:text-[#BFC0C0] relative h-8 w-auto cursor-pointer z-1 rounded-full bg-surface-raised/80 dark:bg-transparent backdrop-blur-sm shadow-[0_4px_16px_rgba(11,27,58,0.15)] dark:shadow-none" />
    </button>
  );
}
